import { useState, useCallback } from "react"

export const useRefetch = () => {
  const [isFetching, setIsFetching] = useState(false)

  const reload = useCallback(async refetch => {
    setIsFetching(true)
    try {
      await refetch()
    } catch (e) {
      console.log("error in refresh:", e)
    } finally {
      setIsFetching(false)
    }
  }, [])

  return { isFetching, reload }
}
